import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { DrawerBody, DrawerFooter, Button } from '@one-thd/sui-atomic-components';
import { RatingsAndReviewsCondensed } from '@thd-olt-component-react/ratings-and-reviews';
import { AddToContext } from '../../AddToContext';
import { SCREENS } from '../../AddToConstants';

export const ProductReviews = ({ itemId, updateList }) => {
  const { setScreen, addToType } = useContext(AddToContext);
  const { PROJECT_SELECT_GROUP, DEFAULT } = SCREENS;

  const handleSubmit = async () => {
    if (addToType === 'List') {
      await updateList({
        variables: {
          products: [{ itemId, quantity: 1 }]
        }
      });
      setScreen(DEFAULT);
    } else {
      setScreen(PROJECT_SELECT_GROUP);
    }
  };

  return (
    <>
      <DrawerBody data-testid="test-productreviews">
        <RatingsAndReviewsCondensed itemId={itemId} />
      </DrawerBody>
      <DrawerFooter position="center">
        <Button
          data-testid="productReviews-AITP-button"
          variant="secondary"
          fullWidth
          onClick={handleSubmit}
          type="submit"
        >
          Add to {addToType}
        </Button>
      </DrawerFooter>
    </>
  );
};

ProductReviews.displayName = 'ProductReviews';

ProductReviews.propTypes = {
  itemId: PropTypes.string.isRequired,
  updateList: PropTypes.func
};

ProductReviews.defaultProps = {
  updateList: () => {}
};

ProductReviews.dataModel = extend(RatingsAndReviewsCondensed);
